import { Component, OnInit, ElementRef, ViewChild, HostBinding, OnDestroy } from '@angular/core';
import { GenericoService } from 'src/app/shared/services/generico.service';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { DatePipe, NgIf, NgFor, AsyncPipe } from '@angular/common';
import { EmpleadoService } from 'src/app/empleado/empleado.service';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import { Persona } from 'src/app/shared/model/security/persona.model';
import { Puesto } from 'src/app/shared/model/empleado/puesto.model';
import { Area } from 'src/app/shared/model/empleado/area.model';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom, forkJoin, Observable, ReplaySubject, Subscription } from 'rxjs';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { GestionclientesService } from 'src/app/clientes/gestionclientes.service';
import { HttpErrorResponse } from '@angular/common/http';
import {Constantes} from '../../utilerias/constantes/constantes';
import { SweetAlertComponent } from 'src/app/shared/SweetMesssage';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { FechaDirective } from '../../utilerias/directives/fecha.directive';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { ReporteHrTrabajadasComponent } from './reporte-hr-trabajadas/reporte-hr-trabajadas.component';

@Component({
    selector: 'app-bitacoras',
    standalone: true,
    templateUrl: './bitacoras.component.html',
    styleUrls: ['./bitacoras.component.css'],
    providers: [DatePipe],
    imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatFormField, MatLabel, MatSelect, MatOption, NgIf, FormsModule, NgFor, MatInput, MatDatepickerInput, FechaDirective, MatDatepickerToggle, MatSuffix, MatDatepicker, MatIcon, NgxMatSelectSearchModule, ReactiveFormsModule, MatButton, ReporteHrTrabajadasComponent, AsyncPipe, NgxPaginationModule]
})
export class BitacorasComponent implements OnInit, OnDestroy {
  requestEmpleados;
  filtroSeleccionado = 0;
  proyectos: Proyecto[];
  empleados: Empleado[];
  areas: Area[];
  areasReporte: Area[];
  mostrarProyectos: boolean;
  mostrarEmpleados: boolean;
  fechaInicio = new Date();
  fechaFin = new Date();
  fechaMax= new Date();
  proyectoSeleccionado: Proyecto;
  empleadoSeleccionado: Empleado;
  areaSelecconada: Area;
  // Request para lista clientes
  requestCliente = new ConsultaList<Cliente>();
  // Valor inicial de Página Cliente
  regPagCliente = 1000;

  @ViewChild('downloadReporteExcell') private downloadReporteExcell: ElementRef;

  /****************  Variables para reportes Colaborador/Proyecto. *************/
  // Declaración de formulario.
  // formColaborador: FormGroup;
  colaboradorByHrs = new FormControl();
  areaByHrs = new FormControl();
  // Lista de empleados.
  empleadosReport: Empleado[];
  empleadosReportProyecto: Empleado[];
  // Lista tipo proyecto.
  proyectosReport: Proyecto[];
  // Listas.
  listaEmpleadoGrid: any[];
  listaClientes: Array<Cliente>;
  // Declaración de filterOptions para filtro.
  filteredOptions: Observable<Empleado[]>;
  filteredOptionsArea: Observable<Area[]>;
  filteredOptionsProyecto: Observable<Proyecto[]>;
  filteredOptionsEmpProyecto: Observable<Empleado[]>;
  userControl = new FormControl();
  // Id para Busquedad
  idColabolador: number = null;
  // -- Id para reporte por proyecto.
  idProyecto: string = null;
  idClienteProyecto: number = null;
  idColaboladorProyecto: number = null;
  // Id de Area
  idArea: number = null;
  // Variable para fecha maxima
  maxDate: Date;
  maxDateProy: Date;
  // Variable para fecha minima.
  minDate: Date;
  minDateProy: Date;
  // Variable para definicion de dias (Lunes/Viernes).
  fechaLunes: Date;
  fechaViernes: Date;
  // Variables para mostrar numero de registros
  // en grid de datos.
  @HostBinding('class.is-open')
  isOpen = false;
  // Bandera para regresar Pagina
  regresaPag: boolean = false;
  private subscription: Subscription;
  // Bandera para mostrar o ocultar panel.
  panelOpenState = false;
  // Declaración de lista.
  empleado: ConsultaList<Empleado>;
  consultaProyecto: ConsultaList<Proyecto>;
  // Creación de objeto ReplaySubject
  public filterEmpleadoByHrs: ReplaySubject<Empleado[]> = new ReplaySubject<Empleado[]>(1);
  public filterAreaByHrs: ReplaySubject<Area[]> = new ReplaySubject<Area[]>(1);
  // Modelo para filtros.
  modelColaboradorHr: any;
  modelAreaHr: any;
  modelFechaInicio: any;
  modelFechaFin: any;

  modelProyecto: any;
  modelClienteProyecto: any;
  modelColaboradorProyecto: any;
  modelFechaInicioProy: any;
  modelFechaFinProy: any;
  ahora: any; 
  totalRegistrosReporteHoras = 0;
  currentPageReporteHoras = 1;
  readonly pageSize = 10;
  public labels: { previousLabel: string; nextLabel: string } = {
    previousLabel: 'ANTERIOR',
    nextLabel: 'SIGUIENTE'
  };

  valorPanel = null;
  constructor(private genService: GenericoService, private msg: Msg, private datePipe: DatePipe,
    private empleadosService: EmpleadoService, private generico: GenericoService, private clientService: GestionclientesService,private sweetAlert: SweetAlertComponent) {
  }

  ngOnInit() {

    const datePite = new DatePipe('en-Es')
		this.ahora = datePite.transform(new Date(), 'yyyy-MM-dd')
    // Fechas semanal
    var curr = new Date();
    this.maxDate = new Date(curr.setDate(curr.getDate() - curr.getDay() + 5));
    this.minDate = new Date();
    this.generaParametrosConsulta();

    // Asiganción de valores 
    this.requestCliente.regInicial = 0;
    this.requestCliente.regXPagina = this.regPagCliente;

    this.colaboradorByHrs.valueChanges.subscribe(() => { this.filtraEmpleadoByHrs() });
    this.areaByHrs.valueChanges.subscribe(() => { this.filtraAreaByHrs() })
    this.consultaPaginaReporteHoras(1);

    // Consulta de catálogos.
    forkJoin([this.consultaFechaSemanal(), this.consultaProyectosActivos(),
    this.consultarEmpleados(), this.consultaAreas(), this.consultarClientes()]);
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    this.generico.getEstatusPantalla(false);
  }

  consultarClientes(): void {
    this.clientService.filtroBusquedaCliente(this.requestCliente).subscribe(res => {
      if (res.pCodRetorno === '00000') {
        this.listaClientes = res.list;
      } else {
        this.listaClientes = new Array<Cliente>();
      }
    });
  }

  consultaProyectosActivos() {
    
    firstValueFrom(this.genService.obtenerColeccion(UrlConstantes.consultaProyectosSinFiltro2)).then(res => {
      
      this.proyectos = res;
      // Lista para filtro reporte.
      this.proyectosReport = res;
    }).catch(() => {
     
      this.msg.errorCall("No se pudo consultar los proyectos", null, null);
    });
  }

  consultarEmpleados(): void {
 
    this.requestEmpleados = new ConsultaList<Empleado>();
    this.requestEmpleados.regXPagina = 10000;
    this.requestEmpleados.regInicial = 0;
    this.requestEmpleados.bean = new Empleado();
    this.requestEmpleados.bean.usuario = new Usuario();
    this.requestEmpleados.bean.persona = new Persona();
    this.requestEmpleados.bean.puesto = new Puesto();
    firstValueFrom(this.empleadosService.consultaEmpleados(this.requestEmpleados)).then(res => {
    
      if (res.list.length !== 0) {
        this.empleados = res.list;
        this.empleadosReport = res.list;
        this.empleadosReportProyecto = res.list;
        this.filterEmpleadoByHrs.next(this.empleadosReport);
      }
    }).catch(error => {
    
      this.msg.errorCall("No se pudo consultar los empleados", null, null);
    });
  }

  consultaAreas(): void {
   
    firstValueFrom(this.empleadosService.consultaAreas()).then(res => {
     
      this.areas = res.list;
      this.areasReporte = res.list;
      this.filterAreaByHrs.next(this.areasReporte.slice());
    }).catch(() => {
     
      this.msg.errorCall("No se pudo descargar la bítacora, intente más tarde", null, null);
    });
  }

  descargarBitacorasGenerico(url, zipName, tipo, extencion) {
  
    var params = this.generaParametrosConsulta();
    firstValueFrom(this.genService.descargarBitacoras(url, params[0], params[1], params[2], params[3], params[4])).then(
      resp => {
        
        const blob = new Blob([resp],
          {
            type: 'application/' + tipo
          }
        );
        const fileUrl = window.URL.createObjectURL(blob);
        const link = this.downloadReporteExcell.nativeElement;
        link.href = fileUrl;
        link.download = zipName + extencion;
        link.click();
        window.URL.revokeObjectURL(fileUrl);
      }
    ).catch((errorResponse: HttpErrorResponse) => {
      
      if(errorResponse.status == Constantes.NOT_FOUND) {
        this.msg.errorCall(Constantes.SIN_RESULTADOS, null, null);
      }
      if(errorResponse.status == Constantes.INTERNAL_SERVER_ERROR) {
        this.msg.errorCall("No se  pudo descargar las bitácoras, intente más tarde", null, null);
      }
    }
    );
  }
  descargarBitacora() {
    if (this.validarFormulario()) {
      switch (this.filtroSeleccionado) {
        case 1:
          this.descargarBitacorasGenerico("bitacorasTodas.do",
            "Bitacoras" + this.datePipe.transform(new Date(), 'dd/MM/yyyy'), "zip", ".zip")
          break;
        case 2:
          this.descargarBitacorasGenerico("bitacorasProyecto.do", this.proyectoSeleccionado.nombre_corto, "zip", ".zip");
          break;
        case 3:
          this.descargarBitacorasGenerico("bitacorasArea.do", this.areaSelecconada.area, "zip", ".zip");
          break;
        case 4:
          this.descargarBitacorasGenerico("bitacoraUsuario.do", this.empleadoSeleccionado.persona.nombreCompleto, "x-download", ".xlsx");
          break;
      }
    } else {
      this.msg.errorCall("Debe ingresar los datos necesarios de acuerdo al filtro", null, null);
    }
  }
  generaParametrosConsulta(): any[] {
    var params = [];
    params[0] = this.proyectoSeleccionado != undefined ? this.proyectoSeleccionado.id : null;
    params[1] = this.empleadoSeleccionado != undefined ? this.empleadoSeleccionado.usuario.id : null;
    params[2] = this.fechaInicio != undefined ? this.datePipe.transform(this.fechaInicio, 'dd/MM/yyyy') : null;
    params[3] = this.fechaFin != undefined ? this.datePipe.transform(this.fechaFin, 'dd/MM/yyyy') : null;
    params[4] = this.areaSelecconada != undefined ? this.areaSelecconada.id : null;
    return params;
  }
  ocultarMostrarFiltros(id) {
    this.filtroSeleccionado = id;
    if (id != 2)
      this.proyectoSeleccionado = null;
    if (id != 3)
      this.areaSelecconada = null;
    if (id != 4)
      this.empleadoSeleccionado = null;
  }
  validarFormulario(): boolean {
    let valido = true;
    switch (this.filtroSeleccionado) {
      case 0:
        valido = false;
        break;
      case 2:
        if (this.proyectoSeleccionado == null)
          valido = false;
        break;
      case 3:
        if (this.areaSelecconada == null)
          valido = false;
        break;
      case 4:
        if (this.empleadoSeleccionado == null)
          valido = false;
        break;
    }
    return valido;
  }
  /************************** Metódo para reportes por horas ****************************/

  consultaListaSemanal() {
    this.maxDate = this.modelFechaFin !== '' ? new Date(this.modelFechaFin) : new Date();
    this.minDate = this.modelFechaInicio !== '' ? new Date(this.modelFechaInicio) : new Date();
  }
  consultaFechaSemanal() {
    var dateActual = new Date();
    this.fechaLunes = new Date(dateActual.setDate(dateActual.getDate() - dateActual.getDay() + 1));
    this.fechaViernes = new Date(dateActual.setDate(dateActual.getDate() - dateActual.getDay() + 5));
  }

  consultaPaginaReporteHoras(page: number): void {
    this.currentPageReporteHoras = page;
    let fecha_ini;
    let fecha_fin;
    if (!this.modelFechaInicio || !this.modelFechaFin) {
      fecha_ini = this.datePipe.transform(this.fechaLunes, 'yyyy-MM-dd');
      fecha_fin = this.datePipe.transform(this.fechaViernes, 'yyyy-MM-dd');
    } else {
      fecha_ini = this.datePipe.transform(this.modelFechaInicio, 'yyyy-MM-dd').toString();
      fecha_fin = this.datePipe.transform(this.modelFechaFin, 'yyyy-MM-dd').toString();
    }
    this.empleado = new ConsultaList<Empleado>();
    this.empleado.param7 = fecha_ini;
    this.empleado.param8 = fecha_fin;
    this.empleado.param4 = this.idColabolador;
    this.empleado.param5 = this.idArea;
    this.empleado.regInicial = (page - 1) * this.pageSize;
    this.empleado.regFinal = this.pageSize;
   
    this.listaEmpleadoGrid = [];
    this.genService.reporteEmpleadoColabolador(this.empleado, 'reporteColaborador.do').subscribe(response => {
      const lista = Array.isArray(response?.list) ? response.list : [];
      this.listaEmpleadoGrid = lista;
      this.totalRegistrosReporteHoras = this.resolveTotalRegistrosReporteHoras(response, lista);

      const maxPages = this.totalPagesReporteHoras;
      if (maxPages > 0 && this.currentPageReporteHoras > maxPages) {
        this.consultaPaginaReporteHoras(maxPages);
      }
    }, error => {
     
    });
  }
  filtro() {
    this.consultaPaginaReporteHoras(1);
  }
  descargarReporteColaborador() {
    let fecha_ini;
    let fecha_fin;
    if (!this.modelFechaInicio || !this.modelFechaFin) {
      fecha_ini = this.datePipe.transform(this.fechaLunes, 'yyyy-MM-dd');
      fecha_fin = this.datePipe.transform(this.fechaViernes, 'yyyy-MM-dd');
    } else {
      fecha_ini = this.datePipe.transform(this.modelFechaInicio, 'yyyy-MM-dd').toString();
      fecha_fin = this.datePipe.transform(this.modelFechaFin, 'yyyy-MM-dd').toString();
    }
  
    this.genService.descargaEmpleadoColabolador('reporteColaborador.do', this.idColabolador, fecha_ini, fecha_fin, this.idArea).subscribe(response => {
   
      const blob = new Blob([response],
        {
          type: 'application/' + "x-download"
        }
      );
      const fileUrl = window.URL.createObjectURL(blob);
      const link = this.downloadReporteExcell.nativeElement;
      if(this.listaEmpleadoGrid.length >= 1){
        link.href = fileUrl;
        link.download = "ReporteHorasTrabajas " + fecha_ini + "-" + fecha_fin + ".xlsx";
        link.click();
        window.URL.revokeObjectURL(fileUrl);
      }else {
        this.sweetAlert.showSwal('error-message-msg', Constantes.SIN_REGISTROS);
       
      }
      
    }, error => {
   
    });
  }


  filtraEmpleadoByHrs() {
    if (!this.empleadosReport) { return; }
    let search = this.colaboradorByHrs.value;
    if (!search) {
      this.filterEmpleadoByHrs.next(this.empleadosReport.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterEmpleadoByHrs.next(
      this.empleadosReport.filter(empleado => empleado.persona.nombreCompleto.toLowerCase().indexOf(search) > -1)
    );
  }
  filtraAreaByHrs() {
    if (!this.areasReporte) { return; }
    let search = this.areaByHrs.value;
    if (!search) {
      this.filterAreaByHrs.next(this.areasReporte.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filterAreaByHrs.next(
      this.areasReporte.filter(empleado => empleado.area.toLowerCase().indexOf(search) > -1)
    );
  }

  limpiarFormularioReporteHoras() {
    this.idColabolador = null;
    this.idArea = null;
    this.modelColaboradorHr = null;
    this.modelAreaHr = null;
    this.modelFechaInicio = null;
    this.modelFechaFin = null;
    this.filtro2();
  }

  filtro2() {
    this.consultaPaginaReporteHoras(1);
  }

  get totalPagesReporteHoras(): number {
    return this.totalRegistrosReporteHoras > 0
      ? Math.ceil(this.totalRegistrosReporteHoras / this.pageSize)
      : 0;
  }

  get showPaginationReporteHoras(): boolean {
    return this.totalRegistrosReporteHoras > 0 || (this.listaEmpleadoGrid?.length ?? 0) > 0;
  }

  private resolveTotalRegistrosReporteHoras(response: any, lista: any[]): number {
    const candidates = [
      response?.param4,
      response?.pTotalItems,
      response?.totalItems,
      response?.totalRegistros,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    return Array.isArray(lista) ? lista.length : 0;
  }

}
